// eslint-disable-next-line
import { BasicLayout } from '@/layout';
import MemberLayout from '@/layout/MemberLayout.vue';

export const asyncRouterMap = [];

/**
 * 基础路由
 * @type { *[] }
 */
export const constantRouterMap = [
  {
    path: '/',
    name: 'Root',
    component: BasicLayout,
    redirect: '/index',
    meta: {
      title: '台州金电保数字科技有限公司',
    },
    children: [
      {
        path: 'index',
        name: 'Index',
        component: () => import('@/views/index.vue'),
        meta: {
          title: '首页',
          hideMenu: true,
        },
      },
      {
        path: 'admin',
        name: '我的信息',
        redirect: '/admin/info',
        component: MemberLayout,
        meta: {
          title: '管理后台',
        },
        children: [
          {
            path: 'info',
            name: 'AdminInfo',
            component: () => import('@/views/admin/info/info.vue'),
            meta: {
              title: '个人信息',
              hideMenu: false,
            },
          },
          {
            path: 'p_contract',
            name: 'PContract',
            component: () => import('@/views/admin/p_contract/index.vue'),
            meta: {
              title: '保函订单',
              hideMenu: false,
            },
          },
          {
            path: 'team_performance',
            name: 'TeamPerformance',
            component: () => import('@/views/admin/team_performance/index.vue'),
            meta: {
              title: '团队业绩',
              hideMenu: false,
            },
          },
        ],
      },
      {
        path: 'contract_check',
        name: 'ContractCheck',
        component: () => import('@/views/contract/check.vue'),
        meta: {
          title: '保函查验',
          hideMenu: true,
        },
      },
      {
        path: 'customer-service',
        name: 'WebCustomerService',
        redirect: () => ({ path: '/index', query: { online_consult: '1' } }),
        meta: {
          title: '在线咨询',
          hideMenu: true,
        },
      },
    ],
  },
  {
    path: '/404',
    name: '404',
    component: () => import(/* webpackChunkName: "fail" */ '@/views/exception/404'),
  },
  { path: '*', name: 'other', redirect: '/404', hidden: true },
];
